import React from 'react'
import { orderbyDate } from '@helpers/helper.novelty'

import { useEffect, useState } from 'react'
import { Novelty, RealEstateDataPageComponentData } from 'types'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { setActiveTags, setActiveNovelties } from '@slices/noveltiesSlice'
import { useDispatch, useSelector } from 'react-redux'
import { ElementHTML } from '@helpers/helper.rendering'

const MOCKDATA = {
  title: 'Titulo de la sección',
  subtitle: 'Subtitulo de la sección',
  noveltyCard: '1',
  is_wide: false,
  titleSecondary: false,
  titleElement: 'h2',
}

const Main_Novelties_Jumbotron = (props: RealEstateDataPageComponentData) => {
  const dispatch = useDispatch()

  const { isDemo } = props
  const {
    global_data: { id: siteId },
  } = props
  const { title, subtitle, is_wide, titleElement, titleSecondary, titleHexa, backgroundSecondary } =
    props

  console.log(titleHexa)
  console.log(backgroundSecondary)

  const [isActiveFilterButton, setIsActiveFilterButton] = useState(false)

  const { tags_active } = useSelector(
    (state: { novelties: { tags_active: number[]; novelties_active: Novelty[] } }) =>
      state.novelties,
  )!

  const [filteredNovelties, setFilteredNovelties] = useState<any>([])

  const { data: allBlogData, isLoading } = useGetBlogsQuery({ site: siteId })

  const toggleTag = (id: number) => {
    setIsActiveFilterButton(true)
    if (tags_active.find((e) => e === id)) {
      if (tags_active?.length === 1) {
        dispatch(setActiveNovelties(allBlogData?.news))
        setIsActiveFilterButton(false)
      }
      return dispatch(setActiveTags(tags_active.filter((e) => e !== id)))
    }
    return dispatch(setActiveTags([...tags_active, id]))
  }

  useEffect(() => {
    if (allBlogData?.news) {
      if (filteredNovelties.length === 0) {
        dispatch(setActiveNovelties(orderbyDate(allBlogData.news)))
      }
    }
  }, [allBlogData])

  const filterNoveltiesAction = () => {
    if (tags_active.length === 0) {
      setIsActiveFilterButton(false)
      dispatch(setActiveNovelties(allBlogData?.news))
      return
    }
    let response = []
    if (allBlogData?.news) {
      for (const novelty of allBlogData?.news) {
        if (novelty.tags.find((t) => tags_active.find((l) => l === t.id))) {
          response.push(novelty)
        }
      }
      setIsActiveFilterButton(false)
    }
    return dispatch(setActiveNovelties(response))
  }

  const isBrowser = typeof window !== 'undefined'

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  console.log(titleSecondary)

  return (
    isMounted && (
      <section
        className={
          'novelty-main p-y-config a ' +
          (backgroundSecondary ? ' dark-theme ' : '') +
          (is_wide ? ' is_wide_component ' : '')
        }
      >
        <div className="container-fluid pb-0">
          <div className={'row ' + (is_wide ? 'align-items-center' : 'align-items-start')}>
            <div
              className={
                'first_div col-12 col-lg-6 align-items-center ' + (is_wide ? 'mb-auto' : '')
              }
            >
              {title && (
                <ElementHTML
                  className={'title ' + (is_wide ? 'text-center mb-4' : ' mb-2')}
                  children={title || 'Novedades'}
                  style={{ color: titleHexa }}
                  elementType={titleElement || 'h2'}
                />
              )}
              {subtitle && (
                <p
                  className={
                    'sub-title ' +
                    (is_wide ? ' text-center mb-4' : '') +
                    (titleSecondary ? ' text-secondary' : '')
                  }
                >
                  {subtitle}
                </p>
              )}
            </div>
            <div className={'mt-4 mt-lg-0 second_div col-12 ' + (!is_wide ? 'col-lg-6' : '')}>
              <div className="div_search d-flex justify-content-between">
                <i className="d-none icon-label-solid me-3"></i>
                <div className="pills_search ms-lg-4 d-flex justify-content-between">
                  <div className="div_pills flex-wrap">
                    {tags_active.map((element, index) => (
                      <span
                        key={index}
                        className="animate__animated animate__fadeInRight pill btn btn-primary me-2 mb-1 mt-2 mt-lg-0"
                      >
                        {allBlogData?.tags.find((item) => item.id === element)?.name}
                        <i
                          onClick={() => toggleTag(element)}
                          className="icon-close-light"
                        ></i>
                      </span>
                    ))}
                    {!tags_active.length && (
                      <div className="placeholder-text">
                        {isBrowser && screen.width > 992
                          ? 'Utilice las etiquetas para filtrar las novedades de su interés.'
                          : 'Utilice las etiquetas para filtrar novedades'}
                      </div>
                    )}
                  </div>
                  <div className="div_buttons d-flex">
                    <button
                      className="btn-clear me-3 d-none d-md-block cursor-pointer"
                      onClick={() => {
                        dispatch(setActiveTags([]))
                        dispatch(setActiveNovelties(allBlogData?.news))
                        setIsActiveFilterButton(false)
                      }}
                    >
                      Limpiar
                    </button>
                    <button
                      className={`btn btn-red btn-share d-none d-lg-flex cursor-pointer ${
                        !isActiveFilterButton && 'btn-disabled'
                      }`}
                      onClick={() => filterNoveltiesAction()}
                    >
                      FILTRAR <i className="icon-search ms-3"></i>
                    </button>
                    <button
                      className={`btn btn-red btn-share-icon d-lg-none cursor-pointer ${
                        !isActiveFilterButton && 'btn-disabled'
                      }`}
                      onClick={() => filterNoveltiesAction()}
                    >
                      <i className="icon-search "></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="div_etiquetas flex-wrap">
                {isLoading
                  ? [1, 2, 3].map((index) => (
                      <div
                        className="me-3 mb-2 d-inline-block"
                        key={index}
                      >
                        <span
                          key={index}
                          className="animate__animated animate__fadeInDown cursor-pointer pill skeleton btn btn-primary me-2 mt-2 mt-lg-0"
                        >
                          ...
                        </span>
                      </div>
                    ))
                  : allBlogData?.tags.map((tag, index) =>
                      tags_active.find((e) => e === tag.id) ? (
                        ''
                      ) : (
                        <span
                          key={index}
                          onClick={() => toggleTag(tag.id)}
                          className="animate__animated animate__fadeInDown cursor-pointer pill btn btn-primary me-2 mt-2 mt-lg-0"
                        >
                          {tag.name}
                        </span>
                      ),
                    )}
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  )
}

export default Main_Novelties_Jumbotron
